import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ChatWindow from './ChatWindow';
import { CHARACTERS } from '../../assets/characters';

const ChatToggle: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AnimatePresence>{isOpen && <ChatWindow onClose={() => setIsOpen(false)} />}</AnimatePresence>

      {!isOpen && (
        <motion.button
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setIsOpen(true)}
          style={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '0.875rem 1.25rem',
            background: 'var(--color-primary)',
            color: '#fff',
            borderRadius: 'var(--radius-full)',
            boxShadow: '0 4px 20px rgba(27,42,74,0.3)',
            zIndex: 1000,
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'var(--font-family)',
            fontWeight: 500,
            fontSize: 'var(--font-size-sm)',
          }}
        >
          <img
            src={CHARACTERS.julia}
            alt=""
            aria-hidden
            style={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              objectFit: 'contain',
              objectPosition: 'center bottom',
              background: 'rgba(255,255,255,0.18)',
            }}
          />
          Julia IA
        </motion.button>
      )}
    </>
  );
};

export default ChatToggle;
